module.exports = __webpack_public_path__ + "img/sty_1.0ff825a5.webp";